import { render, staticRenderFns } from "./MallCustomerService.vue?vue&type=template&id=d04c9ace&"
import script from "./MallCustomerService.vue?vue&type=script&lang=js&"
export * from "./MallCustomerService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports